export enum BackgroundCheckRequestStepsEnum {
  Reason = 'reason',
  CandidateInformation = 'candidate_information',
  SelfDeclaration = 'self_declaration',
  Payment = 'payment',
  IdVerification = 'id_verification',
}
